import { createContext, useContext, useRef, useState } from "react"

import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import { useConsole } from "contexts/Console"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"
import { usePanelModal } from "contexts/PanelModal"
import { useSuspender } from "contexts/Suspender"

export const PopinContext = createContext({})
export function usePopin() {
  return useContext(PopinContext)
}

async function load(path, { console }) {
  return Promise.resolve(new URL(path, process.browser ? global.location.origin : process.env.REVERSE_PROXY_URL))
    .then(url => new Request(url))
    .then(request => fetch(request))
    .then(response => response.json())
    .then(body => [null, body])
    .catch(err => [err, {}])
}

export const PopinContextProvider = ({ children, uid, preload, hasNoGestur /*background, components*/ }) => {
  const console = useConsole()
  const locale = useLocale()
  const navigation = useNavigation()
  const { panelModalState } = usePanelModal()
  const path = navigation.localize(`/popin/${uid}.extra.json`, locale.current.codes.www)
  const [[err, preloaded], preloadSSR] = useSuspender(["pop", path], preload ? () => load(path, { console }) : () => Promise.resolve([null, {}]), preload)
  const [JITData, setJITData] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const closeTrackingHandler = useRef(null)
  // const [step, setStep] = useState("")

  // useEffect(() => {
  //   setStep(sessionStorage?.getItem("contactFormStep") || "")
  // }, [])

  const onClose = () => {
    if (hasNoGestur) {
      // const page = global.digitalDataLayer
      // const step = sessionStorage?.getItem("contactFormStep") || ""
      // let stepName = ""

      // // You can map step to a label if needed
      // if (step === 1) stepName = "message"
      // else if (step === 2) stepName = "information"
      // else stepName = "thankyou"

      // Object.assign({
      //   pageName: `:form:step-${step}:${stepName}`,
      // })

      if (typeof closeTrackingHandler.current !== "function") {
        waTriggerEvent({
          eventName: "itemClosed",
          eventType: "Click",
          // page,
          itemInfo: {
            componentName: "form",
          },
        })
      } else {
        closeTrackingHandler.current()
      }
    }
    setIsOpen(false)
    panelModalState.set(false)
  }

  const onOpen = async () => {
    if (!preload) {
      const [err, body] = await load(path, { console })
      if (err) console.error(err)
      setJITData(body)
    }
    setIsOpen(true)
    panelModalState.set(true)
  }

  const onOverlayClick = evt => {
    // if (evt.clientY >= window.innerHeight / 10 && evt.currentTarget !== evt.target) return
    setIsOpen(false)
    panelModalState.set(false)
  }

  const ctx = {
    ...preloaded,
    ...JITData,
    hasNoGestur,
    isOpen,
    onOpen,
    onClose,
    onOverlayClick,
    setCloseTrackingHandler(handler) {
      closeTrackingHandler.current = handler
    },
  }

  console.verbose("PopinContext(%o)", { uid, preloaded })
  return (
    !err && (
      <>
        {preloadSSR}
        <PopinContext.Provider value={ctx}>{children}</PopinContext.Provider>
      </>
    )
  )
}
